import { createReducer, on } from '@ngrx/store';

import {
  loadAddressFailure,
  loadAddressForCoordinates,
  loadAddressSuccess,
  overwriteAddressMap,
} from '@store/actions/address.actions';
import { initialAddressState } from '@store/state/address.state';

export const addressReducer = createReducer(
  initialAddressState,
  on(loadAddressForCoordinates, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),
  on(loadAddressSuccess, (state, { map }) => ({
    ...state,
    addressMap: { ...state.addressMap, ...map },
    loading: false,
  })),
  on(loadAddressFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(overwriteAddressMap, (state, { map }) => ({
    ...state,
    addressMap: map,
    loading: false,
  })),
);
